import Link from "next/link"
import Blocks from "@/components/Blocks"
import classNames from "classnames/bind"
import styles from "./text-card.module.css"

export default function TextCard({ block }) {
  const { attrs, innerBlocks } = block
  const cx = classNames.bind(styles)

  if (innerBlocks === undefined || innerBlocks.length === 0) {
    return null
  }

  const blockSettings = {
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "core/list": { width: "bleed" },
    "theme/link": {
      width: "bleed",
      noLink: true,
      isButton: true
    }
  }

  const classes = {
    wrapper: true,
    "theme-light-teal": block.attrs.theme === "light-teal",
    "theme-lime": block.attrs.theme === "lime",
    "theme-dark-gray": block.attrs.theme === "dark-gray"
  }

  return (
    <Container {...{ attrs, className: cx(classes) }}>
      <div className="inner-wrapper">
        <Blocks blocks={innerBlocks} settings={blockSettings} />
      </div>
    </Container>
  )
}

const Container = ({ attrs, children, className }) => {
  const hasLink = attrs?.link?.url && attrs.link.url.length > 0

  if (!hasLink) {
    return <div className={className}>{children}</div>
  }

  if (attrs?.link?.target) {
    return (
      <div className={className}>
        <a href={attrs?.link?.url} target="_blank" rel="noreferrer">
          {children}
        </a>
      </div>
    )
  }

  return (
    <div className={className}>
      <Link href={attrs?.link?.url} prefetch={false}>
        {children}
      </Link>
    </div>
  )
}
